import { Component, OnInit, Inject, ViewContainerRef } from '@angular/core';
import { AppService } from '../../../app.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GETInventoryService } from '../services/inventory.service';
import { ErrorMessages } from '../entities/global/error-codes';
import { NotificationsService } from 'angular2-notifications';

@Component({
  selector: 'app-add-repairer-workshop-modal',
  templateUrl: './add-repairer-workshop-modal.component.html',
  styleUrls: ['./add-repairer-workshop-modal.component.css']
})
export class AddRepairerWorkshopModalComponent implements OnInit {

    jobsiteId: number;
    jobsiteName: string;
    repairerId: number;
    repairer: string = "";
    workshop: string = "";
    modalHeader: string = "Add Repairer / Workshop"

    showWorkshop: boolean = false;
    savingChanges: boolean = false;

    constructor(private _appService: AppService, public dialogRef: MatDialogRef<AddRepairerWorkshopModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any, public _inventoryService: GETInventoryService,
        public toastr: NotificationsService, vcr: ViewContainerRef) {
 
    }

    ngOnInit() {
        if (this.data != null) {
            if (this.data.jobsiteId != null) {
                this.jobsiteId = this.data.jobsiteId;
            }
            if (this.data.jobsiteName != null) {
                this.jobsiteName = this.data.jobsiteName;
            }
            if (this.data.repairerId != null) {
                this.repairerId = this.data.repairerId;
                this.showWorkshop = true;
                this.modalHeader = "Add Workshop";
            }
            else {
                this.modalHeader = "Add Repairer";
            }
        }
    }

    onCloseClick(): void {
        this.dialogRef.close();
    }
    saveChanges(): void {
        if (this.savingChanges) {
            return;
        }

        this.savingChanges = true;

        // Create a repairer
        if (this.repairer != "" && this.showWorkshop == false)
        {
            this._inventoryService.createRepairer(this.jobsiteId, this.repairer).subscribe(response => {
                if (response == 0) {
                    this.toastr.error(ErrorMessages.ERROR_SAVING);
                    this.savingChanges = false;
                }
                else {
                    this._inventoryService.setRepairerId(response);
                    this.dialogRef.close();
                }
            }, error => { console.log(error); });
        }
        // Create a workshop
        else
        {
            this._inventoryService.createWorkshop(this.repairerId, this.workshop).subscribe(response => {
                if (response == 0) {
                    this.toastr.error(ErrorMessages.ERROR_Exist);
                    this.savingChanges = false;
                }
                else {
                    this.toastr.success("Workshop created successfully");
                    this._inventoryService.setWorkshopId(response);
                    this.dialogRef.close();
                }
            }, error => { console.log(error); });
        }
    }
}
